module.exports = __webpack_public_path__ + "static/media/37.f852625e.png";